import type { InstrumentRunAssayVersion, InstrumentRunDataRow } from '@/types';

export type ControlRow = Required<
  Pick<InstrumentRunDataRow, 'name' | 'well_position' | 'demux_index' | 'flow_cell' | 'lane'>
> & {
  is_control: true;
  control_type: string;
};

const TAU_BASE_ROWS: ControlRow[] = [1, 2, 3, 4].flatMap(lane =>
  [
    { well_position: 'A1', demux_index: 1 },
    { well_position: 'A2', demux_index: 2 },
    { well_position: 'A3', demux_index: 3 },
  ].map(({ well_position, demux_index }) => ({
    name: 'Library Prep Control',
    flow_cell: '1',
    lane,
    well_position,
    demux_index,
    is_control: true as const,
    control_type: 'Library Prep Control',
  })),
);

const TAU_LP_CONTROL_2_ROW: ControlRow = {
  name: 'Library Prep Control 2',
  flow_cell: '1',
  lane: 4,
  well_position: 'A4',
  demux_index: 2,
  is_control: true,
  control_type: 'Library Prep Control 2',
};

export function getControlRows(
  assayVersion: InstrumentRunAssayVersion,
  numSamples: number,
  useTauLibPrepControl2: boolean,
): ControlRow[] {
  if (assayVersion === 'Tau') {
    const rows = [...TAU_BASE_ROWS];
    if (numSamples === 24 && useTauLibPrepControl2) {
      rows.push(TAU_LP_CONTROL_2_ROW);
    }
    return rows;
  }
  return [];
}
